import { useState, type ReactNode } from "react";
import { useClerk } from "@clerk/react";

// Sign out (Paul, Oct 10). With Clerk (the real site) it ends the Clerk session and goes back to the
// sign-in page. Local development signs in through DEV_AUTH, which has no session to end, so there's
// no button there (main.tsx renders the app outside ClerkProvider, where useClerk would throw).

/** True when the app is signed in through Clerk, so signing out means something. */
export const canSignOut = !!(import.meta.env.VITE_CLERK_PUBLISHABLE_KEY as string | undefined);

function ClerkSignOut({ className, children, role }: { className: string; children: ReactNode; role?: string }) {
  const { signOut } = useClerk();
  const [busy, setBusy] = useState(false);
  return (
    <button
      type="button"
      className={className}
      role={role}
      disabled={busy}
      onClick={() => {
        setBusy(true);
        // Back to the root so a #project link doesn't come along to the next person's sign-in.
        void signOut({ redirectUrl: "/" }).catch(() => setBusy(false));
      }}
    >
      {busy ? "Signing out…" : children}
    </button>
  );
}

/** A sign-out button, or nothing in local development. */
export function SignOutButton({ className = "outline", children = "Sign out", role }: { className?: string; children?: ReactNode; role?: string }) {
  return canSignOut ? (
    <ClerkSignOut className={className} role={role}>
      {children}
    </ClerkSignOut>
  ) : null;
}
